module.exports = __webpack_public_path__ + "img/jaleixo.0fcddd89.png";